export const dividirComissao = ({ codigo, porcentagem, codigo_usuario }) => ({
  type: '@vendas/DIVIDIR_COMISSAO',
  payload: {
    codigo,
    porcentagem,
    codigo_usuario,
  },
});
